<template>
  <div>
    <div class="bg-white padding" style="position: relative; z-index: 2" ref="card" v-show="childBindingList.length>0">
      <div class="input-item flex">
        <div style="display: flex">
          <div class="line"></div>
          <span class="text-nowrap">已綁定子女</span>
        </div>
        <div>
          <span style="font-size: 16px" class="text-blue" @click="changeModifyListStatus">{{ isListInModify ? '完成' : '編輯' }}</span>
        </div>
      </div>
      <div class="dark-card">
        <div v-for="(item, i) in childBindingList" :key="i" class="flex border">
          <div>
            <div style="font-size: 16pt" class="text-gray1">{{ item.student_name | hideName }}</div>
            <div style="font-size: 14px" class="text-gray2">{{ item.student_id_number | hideId }}</div>
          </div>
          <div class="delete-fill" v-if="isListInModify" @click="removeChildBound(item.student_id_number)"></div>
        </div>
      </div>

      <button
        class="text-nowrap"
        :class="isListInModify ? 'btn btn-white' : 'btn btn-primary'"
        style="margin-top: 16pt"
        @click="isListInModify ? addChildBinding() : getPaymentInformation()"
      >
        {{ isListInModify ? '確認學生資料' : '查詢待繳帳單' }}
      </button>
    </div>
    <div class="padding bg-white">
      <div style="padding: 10pt 0 32pt 0" v-if="childBindingList.length==0">
        <div class="input-item flex" style="padding-bottom: 16pt">
          <div style="display: flex; align-items: center">
            <div class="line"></div>
            帶入學生資料
          </div>
        </div>
        <button class="btn btn-primary" @click="addChildBinding">帶入學生資料</button>
      </div>
      <div class="input-item flex">
        <div style="display: flex; align-items: center" class="text-nowrap">
          <div class="line"></div>
          {{ childBindingList.length ? '查詢其他繳費單號' : '輸入繳費單號' }}
        </div>
        <div class="icon-scan" @click="openScanner">掃描</div>
      </div>      
      <div class="input-item-more">繳費單號</div>

      <input
        type="number"
        name="billNumber"
        placeholder="輸入繳費單號"
        class="input"
        pattern="[0-9]*"
        v-model="billNumber"
        @focus="billNumberInFocus = true"
        @blur="billNumberInFocus = false"
      />

      <div class="border-bottom" :style="billNumberBorderStyle"></div>
      <button class="btn btn-primary" :disabled="searchBtnDisabled" @click="queryPaymentInformation">查詢待繳帳單</button>
    </div>
    <div class="padding description">
      <ul class="text-gray2">
        <li>可使用悠遊付錢包、銀行帳戶連結、信用卡(<span class="text-blue">限台新銀行、玉山銀行發卡</span>)進行繳費扣款。</li>
        <li>逾期請至學校辦理繳納，並依校規辦理。</li>
        <li>繳費單據若經修改，與查詢結果不符，請勿使用智慧支付繳費。</li>
        <li>若已在超商繳費、其他繳費平台或與銀行約定自動扣繳，請勿重覆繳費。</li>
        <li>學雜費屬學校公款，一經繳款成功，各代收單位不得取消，家長如有特殊需求(如重覆繳費等)，得於事後向學校申請退費。</li>
      </ul>
    </div>
    <div v-if="dialog">
      <div class="dialog">
        <div class="img-box"><img src="../../assets/images/familyId@3x.png" /></div>
        <div class="dialog-text">
          是否要將把您的身分證字號
          <br />
          傳送至台北市教育局
          <br />
          查詢親子關係?
        </div>
        <div class="agree-label" style="margin-bottom: 16pt">
          <input type="checkbox" id="isAddFavoriteChecked" v-model="isAddFavoriteChecked" @click.stop="clickAgreeBtn" />
          <label for="isAddFavoriteChecked">
            我已經詳閱並同意
            <router-link :to="'/tuition/termsOfPolicy'" class="text-blue">悠遊付會員為申請親子綁定及學校費用繳納個資提供同意條款</router-link>
          </label>
        </div>
        <button class="btn btn-primary" @click="goAddList" :disabled="agreeTermsChecked">確定</button>
        <button class="btn btn-white" style="border: 0" @click="dialog = !dialog">取消</button>
      </div>
      <div class="dialog-mask"></div>
    </div>
    <div :class="isListInModify ? 'mask' : ''" ref="mask"></div>
  </div>
</template>
<script>
import { queryChildBinding, deleteChildBinding, queryChildCanBind, queryBillList } from '../../api/api';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'tuition-fee-list',
  data() {
    return {
      childBindingList: [],
      billNumber: '',
      dialog: false,
      isAddFavoriteChecked: false,
      billNumberInFocus: false,
      isListInModify: false,
    };
  },
  created() {
    this.queryChildBound();
    window.getScanningResult = this.getScanningResult;
  },
  mounted() {
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path === '/tuition/termsOfPolicy') {
        vm.dialog = true;
        vm.isAddFavoriteChecked = vm.isTuitionFeeAgreementChecked;
      }
    });
  },
  filters: {
    hideName(value) {
      let first = value.substr(0, 1);
      let last = value.substr(-1, 1);
      let hide = '';
      for (let i = 0; i < value.length - 2; i++) {
        hide += 'O';
      }
      return `${first}${hide}${last}`;
    },
    hideId(value) {
      let first = value.substr(0, 3);
      let last = value.substr(6, 4);
      let hide = '';
      for (let i = 0; i < value.length - 7; i++) {
        hide += '*';
      }
      return `${first}${hide}${last}`;
    },
  },
  computed: {
    ...mapGetters(['isTuitionFeeAgreementChecked']),
    ...mapActions(['sentApp']),
    billNumberBorderStyle() {
      return this.billNumberInFocus ? 'background: #007ac8' : 'background: #c7c7c7';
    },
    searchBtnDisabled() {
      return this.billNumber === '';
    },
    agreeTermsChecked() {
      return !this.isAddFavoriteChecked;
    },
  },
  methods: {
    openScanner() {
      let form = Object.assign({}, this.form);
      for (let k in this.verify) {
        if (this.verify[k].status === false) {
          form[k] = '';
        }
      }
      this.$store.dispatch('sentApp', {
        action: 'openScanner',
        payload: { type: 4, content: form, isAllowInput: false },
      });
    },
    getFormData(data) {
      this.billNumber = data;
    },
    getScanningResult(qrCode) {
      if (qrCode!==null && qrCode!==undefined && (qrCode.startsWith('https://pyttwb.gov.taipei/') || qrCode.startsWith('https://pay.taipei/'))) {
        let url = new URL(qrCode);
        let paths = url.pathname.split('/');
        if (paths[1] === 'qr' && paths[2] === '16') {
          let data = paths[3];
          this.getFormData(data);
        } else {
          alert('不正確的學雜費繳費條碼格式，請確認後再輸入');
        }        
      }
      this.openScan = false;
    },
    queryChildBound() {
      queryChildBinding().then((res) => {
        if (res.error == undefined) {
          this.childBindingList = res.child_binding_list;
          setTimeout(() => {
            var height = this.$refs.card.clientHeight;
            this.$refs.mask.style.top = height + 'px';
          }, 1000);
        }
      });
    },
    changeModifyListStatus() {
      this.isListInModify = !this.isListInModify;
    },
    addChildBinding() {
      this.dialog = true;
    },
    clickAgreeBtn() {
      this.isAddFavoriteChecked = !this.isAddFavoriteChecked;
    },
    goAddList() {
      if (this.isAddFavoriteChecked) {
        this.dialog = false;
        queryChildCanBind().then((res) => {
          if (!res.error) {
            if (res.child_can_bind_list.length) {
              this.$router.push('/tuitionFee/childBindingAddList');
            }
            if (!res.child_can_bind_list.length) {
              this.$store.dispatch('sentApp', {
                action: 'showNoChildrenDataDialog',
                payload: {
                  title: '查無親子關係綁定資料，詳情請至台北市教育局查詢',
                  button0: '開啟台北市教育局查詢',
                  button1: '確定',
                  externalUrl: 'https://www.doe.gov.taipei/',
                },
              });
            }
          } else {
            alert(res.error.message);
          }
        });
      }
    },
    searchBill(billNumber) {
      this.$router.push({
        path: '/goPay',
        query: { payment_item_id: 16, payment_custom_id: billNumber, payment_query_type: 2 },
      });
    },
    getPaymentInformation() {
      sessionStorage.setItem('childBindList', JSON.stringify(this.childBindingList));
      this.$router.push({
        path: '/goPay',
        query: {
          payment_item_id: 16,
          payment_query_type: 1,
        },
      });
    },
    queryPaymentInformation() {
      const form = {
        payment_item_id: 16,
        payment_query_type: 2,
        parameter1: '',
        parameter2: '',
        parameter3: '',
        payment_custom_id: this.billNumber,
      };
      queryBillList(form).then((res) => {
        if (!res.error) {
          this.searchBill(this.billNumber);
        } else {
          alert(res.error.message);
        }
      });
    },
    removeChildBound(id) {
      if (confirm('確定要刪除？')) {
        deleteChildBinding({ student_id_number: id }).then((res) => {
          if (!res.error) {
            this.isListInModify = false;
            this.queryChildBound();
          } else {
            alert(res.error.message);
          }
        });
      }
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dark-card {
  background-color: #f9f9f9;
}

.dialog {
  z-index: 99;
  background-color: #fff;
  padding: 24pt 20pt;
  border-radius: 16pt;
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10%;

  .img-box {
    width: 100%;
    padding: 0 20pt 16pt 20pt;

    img {
      width: 100%;
    }
  }

  .dialog-text {
    text-align: center;
    font-size: 18px;
  }

  .agree-label {
    font-size: 14px;
    margin: 34pt 0 18pt 0;
    position: relative;

    label {
      text-align: left;
      display: inline-block;
      margin-left: 40px;
      vertical-align: center;
      align-items: center;
    }

    a:active {
      -webkit-tap-highlight-color: transparent;
    }
  }

  .agree-label label::before {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}

.btn-white {
  border: 1px solid rgb(64, 64, 64);
}
</style>
